export const determineProgressColor = (percent, color) => {
  let shade = Math.round(percent / 10) * 100

  if (shade < 100) {
    shade = 50
  }

  return `var(--${color}-${shade})`
}
